import React from 'react'
import { Link } from 'react-router-dom'
import { Badge, Col, Row } from 'react-bootstrap'
import moment from 'moment'

// Hooks
import { useEffect, useState, useQuery, useGlobal } from '../../../../hooks'

// Components
import UIEmpty from '../../../UI/Empty'
import UILoading from '../../../UI/Loading'
import UIError from '../../../UI/Error'
import UIPagination from '../../../UI/Pagination'
import UITable from '../../../UI/Table'
import UITableBody from '../../../UI/Table/Body'
import UITableHead from '../../../UI/Table/Head'
import UIForm from '../../../UI/FormReload'
import UIButton from '../../../UI/Button'

// Queries
import { LIST_CREATED_INSPECTIONS } from './queries'

const InspectionsFieldList = ({ showCreateForm, setShowCreateForm }) => {
  const [{ me }] = useGlobal()

  const [pagination, setPaginationState] = useState({
    limit: 25,
    page: 1,
    idSite: 0,
  })

  // --------------------------------------------------------------------------
  //
  // Query: Received samples
  //
  // --------------------------------------------------------------------------

  const { data, loading, refetch } = useQuery(LIST_CREATED_INSPECTIONS, {
    fetchPolicy: 'network-only',
    variables: { ...pagination },
    onSuccess: ({ pagination }) => {
      setPaginationState((prev) => ({ ...prev, ...pagination }))
    },
    onErrorMessage: `No se pudo obtener la lista de inspecciones.`,
  })

  useEffect(() => {
    refetch()
  }, [me.laboratory, showCreateForm])

  // --------------------------------------------------------------------------
  //
  // Render
  //
  // --------------------------------------------------------------------------

  // Loading
  if (loading) return <UILoading />

  // Data
  if (data && data.i1InspectionsByStage && data.i1InspectionsByStage.data) {
    const { inspections } = data.i1InspectionsByStage.data
    const pagination = data.i1InspectionsByStage.pagination

    const handlePageChange = (page) => {
      setPaginationState((prev) => ({ ...prev, ...pagination, page }))
    }

    return (
      <UIForm>
        <Row className="m-0 mb-4">
          <Col className="text-left">
            <UIButton
              variant="success font-weight-light"
              onClick={() => setShowCreateForm((prev) => !prev)}
            >
              Nueva inspección
            </UIButton>
          </Col>
          <Col className="text-right">
            <Badge
              className="px-2 py-2"
              variant="secondary"
              style={{ fontSize: '11pt' }}
            >
              Total inspecciones: {inspections.length}
            </Badge>
          </Col>
        </Row>
        {inspections.length > 0 ? (
          <>
            <UITable>
              <UITableHead>
                {[' ', 'Tipo de inspección', 'Faena', 'Equipo'].filter(
                  (h) => !!h,
                )}
              </UITableHead>
              <UITableBody>
                {inspections.map((inspection) => (
                  <tr key={inspection.id}>
                    <td style={{ width: '120px' }}>
                      <Link
                        className={`text-decoration-none text-stng-darker`}
                        to={`/inspections/field/${inspection.id}`}
                      >
                        <UIButton
                          variant="stng"
                          style={{ width: '100px' }}
                          className="btn-sm p-1"
                        >
                          Abrir
                        </UIButton>
                      </Link>
                    </td>
                    {/*<td>{inspection.id}</td>*/}
                    <td>{inspection.type}</td>
                    <td>{inspection.site}</td>
                    <td>{inspection.machine}</td>
                    {/*<td>
                      {inspection.date_creation &&
                        moment(inspection.date_created).format('DD/MM/YYYY')}
                    </td>*/}
                  </tr>
                ))}
              </UITableBody>
            </UITable>
            <UIPagination pagination={pagination} onClick={handlePageChange} />
          </>
        ) : (
          <UIEmpty message="No hay nuevas inspecciones creradas" />
        )}
      </UIForm>
    )
  }

  // Error
  return <UIError />
}
export default InspectionsFieldList
